export const getIntegrationLogo = (integrationIdn: string) => {
    return `https://static.newo.ai/integrations/${integrationIdn}/images/logo.svg`;
};

export const getIntegrationDescription = (integrationIdn: string) => {
    return `https://static.newo.ai/integrations/${integrationIdn}/docs/description.html`;
};
